// src/pages/GuestDetailsPageWrapper.tsx
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import { loginAndFetchInitialData } from "../services/LoginService";
import { getToken, isTokenExpired } from "../services/AuthService";
import GuestDetailsPage from "./GuestDetailsPage";
import { CircularProgress } from "@mui/material";
import { useBrandAppearance } from "../hooks/useBrandAppearance";

const GuestDetailsPageWrapper: React.FC = () => {
    const { state, dispatch } = useContext(AppContext)!;
    const [loading, setLoading] = useState(true);

    const { colors: BrandColors } = useBrandAppearance();

    useEffect(() => {
        const hydrate = async () => {
            const token = getToken();
            const expired = isTokenExpired();
            const lastName = sessionStorage.getItem("lastName");
            const confirmationNumber = sessionStorage.getItem("confirmationNumber");

            if (token && !expired && lastName && confirmationNumber && state.guests.length === 0) {
                await loginAndFetchInitialData(lastName, confirmationNumber, dispatch);
            }
            setLoading(false);
        };

        hydrate();
        // Run once on mount. dispatch and guest count are read only for the empty-state restore.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading || state.guests.length === 0) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100dvh",
                textAlign: "center",
            }}
        >
            <CircularProgress size={48} thickness={4} style={{ color: BrandColors.currentStep }} />
            <p style={{ marginTop: 16, fontSize: "1.1rem", color: "#333" }}>
                Loading guest data...
            </p>
        </div>
    );
}


    return <GuestDetailsPage />;
};

export default GuestDetailsPageWrapper;
